/**
 * Calculate estimated due date (EDD) from last menstrual period (LMP)
 * Uses Naegele's rule: LMP + 280 days (or LMP + 9 months + 7 days)
 */
export function calculateDueDate(lmpDate: string): Date {
  const lmp = new Date(lmpDate)
  const edd = new Date(lmp)
  edd.setDate(edd.getDate() + 280)
  return edd
}

/**
 * Calculate gestational age in weeks and days from LMP to current date
 */
export function calculateGestationalAge(lmpDate: string, currentDate: Date = new Date()): {
  weeks: number
  days: number
  display: string
} {
  // Handle date string parsing - add time if not present to avoid timezone issues
  let lmp: Date
  if (lmpDate.includes('T')) {
    lmp = new Date(lmpDate)
  } else {
    // If just date string (YYYY-MM-DD), add time to avoid timezone issues
    lmp = new Date(lmpDate + 'T00:00:00')
  }
  
  // Validate dates
  if (isNaN(lmp.getTime()) || isNaN(currentDate.getTime())) {
    return {
      weeks: 0,
      days: 0,
      display: 'Invalid date',
    }
  }
  
  const diffMs = currentDate.getTime() - lmp.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  
  // Handle negative values (visit date before LMP)
  if (diffDays < 0) {
    return {
      weeks: 0,
      days: 0,
      display: 'Visit date is before LMP',
    }
  }
  
  const weeks = Math.floor(diffDays / 7)
  const days = diffDays % 7
  
  return {
    weeks,
    days,
    display: `${weeks} weeks ${days} days`,
  }
}

/**
 * Format gestational age for display
 */
export function formatGestationalAge(weeks: number, days: number): string {
  return `${weeks} weeks ${days} days`
}
